/* eslint-disable import/first */
import { lazy } from "react";
import MapIcon from "@material-ui/icons/Map";
import PublishIcon from "@material-ui/icons/Publish";
import PaletteIcon from "@mui/icons-material/Palette";
import AssessmentIcon from "@material-ui/icons/Assessment";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CollectionsIcon from "@material-ui/icons/Collections";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import PhotoSizeSelectActualIcon from "@material-ui/icons/PhotoSizeSelectActual";
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import TuneIcon from "@material-ui/icons/Tune";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";

const UploadLocation = lazy(() => import("views/uploadlocation"));
const ImageGallery = lazy(() => import("views/imagegallery"));
const MyAccount = lazy(() => import("views/account"));
const ProfileV2 = lazy(() => import("views/profilev2"));
const HowWork = lazy(() => import("views/howwork"));
const Policy = lazy(() => import("views/policy"));
const Terms = lazy(() => import("views/terms"));
const Privacy = lazy(() => import("views/privacy"));
const Help = lazy(() => import("views/help"));
const Feedback = lazy(() => import("views/feedback"));
const Marketing = lazy(() => import("views/marketing"));
const ViewStatistics = lazy(() => import("views/viewstatistics"));
const AdvancedFunctions = lazy(() => import("views/advancedfunctions"));
const PromotionalMediaPage = lazy(() => import("views/advancedfunctions/PromotionalMediaPage"));
const UploadVideoGalleryPage = lazy(() => import("views/advancedfunctions/UploadVideoGalleryPage"));
const AlbumsPage = lazy(() => import("views/advancedfunctions/AlbumsPage"));
const PrivacyLevelsPage = lazy(() => import("views/advancedfunctions/PrivacyLevelsPage"));

export const BOSSFOTOS_INFO_SUBDOMAIN_BASE_URL = "https://info.bossfotos.com";

export const dashboardRoutes = [
  // {
  //     showable: false,
  //     galleryable: true,
  //     path: `/photographer/creategallery`,
  //     name: "Home",
  //     icon: AccountCircleIcon,
  //     component: ImageGallery,
  //     underline: true,
  // },
  {
    showable: false,
    galleryable: false,
    path: `/photographer/uploadlocation`,
    name: "UploadLocation",
    icon: MapIcon,
    component: UploadLocation,
  },
  // {
  //     path: '#',
  //     icon: null,
  //     showable: true,
  //     galleryable: true,
  //     name: "Load New Items",
  //     component: ImageGallery
  // },
  // {
  //     showable: true,
  //     galleryable: false,
  //     path: `/photographer/map/new`,
  //     name: "Create New Gallery",
  //     icon: EditIcon,
  //     component: ImageGallery,
  // },
  {
    showable: false,
    galleryable: false,
    path: `/photographer/photos`,
    name: "Load Photos",
    icon: CloudUploadIcon,
    component: ImageGallery,
  },
  {
    path: "#",
    icon: DashboardOutlinedIcon,
    showable: true,
    galleryable: false,
    name: "View/Manage",
    component: ImageGallery,
  },
  {
    showable: false,
    galleryable: false,
    path: `/photographer/events`,
    name: "Events",
    icon: EmojiEventsIcon,
    component: ImageGallery,
  },
  {
    showable: true,
    groupChild: true,
    galleryable: false,
    path: `/photographer/map`,
    name: "Galleries",
    icon: CollectionsIcon,
    component: ImageGallery,
  },
  {
    showable: true,
    groupChild: true,
    galleryable: false,
    path: `/photographer/gallery/:id/view`,
    name: "Photos",
    icon: PhotoSizeSelectActualIcon,
    component: ImageGallery,
  },
  {
    showable: false,
    galleryable: false,
    name: "Photo Art",
    icon: PaletteIcon,
    path: "/photographer/photo_art_gallery",
    component: ImageGallery,
  },
  {
    showable: false,
    galleryable: false,
    path: `/photographer/pricing`,
    name: "Pricing",
    icon: MonetizationOnIcon,
    component: ImageGallery,
  },
  {
    path: "#",
    icon: AttachMoneyIcon,
    name: "Sales",
    showable: true,
    galleryable: false,
    component: ImageGallery,
  },
  {
    showable: false,
    galleryable: false,
    path: `/photographer/sold`,
    name: "Photos Sold",
    icon: PublishIcon,
    component: ImageGallery,
  },
  {
    showable: true,
    groupChild: true,
    galleryable: false,
    path: `/photographer/myaccount`,
    name: "Analysis",
    icon: AssessmentOutlinedIcon,
    component: MyAccount,
  },
  {
    showable: false,
    galleryable: false,
    path: `/photographer/analysis`,
    name: "Analysis",
    icon: AssessmentIcon,
    component: ImageGallery,
  },

  {
    showable: false,
    path: `/photographer/editdetails`,
    name: "Edit My Details",
    icon: AccountCircleIcon,
    component: ProfileV2,
    underline: false,
  },
  // {
  //     showable: true,
  //     path: `/photographer/rule`,
  //     name: "Tips & Policies",
  //     icon: GavelIcon,
  //     component: Policy,
  //     underline: false,
  // },
  // {
  //     showable: true,
  //     path: `/photographer/toolbox`,
  //     name: "Marketing Tool Box",
  //     icon: BuildIcon,
  //     component: Marketing,
  //     underline: true,
  // },
  // {
  //     showable: true,
  //     path: `/photographer/statistics`,
  //     name: "View Statistics",
  //     icon: AssessmentIcon,
  //     component: ViewStatistics,
  //     underline: false,
  // },

  // {
  //     showable: true,
  //     path: `/photographer/feedback`,
  //     name: "Feedback",
  //     icon: FeedbackIcon,
  //     component: Feedback,
  //     underline: true,
  // },
  {
    showable: false,
    path: `/photographer/advanced/privacy-levels`,
    name: "Privacy Levels",
    icon: TuneIcon,
    galleryable: false,
    component: PrivacyLevelsPage,
    underline: false,
  },
  {
    showable: false,
    path: `/photographer/advanced/albums`,
    name: "Create/Edit Albums",
    icon: TuneIcon,
    galleryable: false,
    component: AlbumsPage,
    underline: false,
  },
  {
    showable: false,
    path: `/photographer/advanced/upload-video`,
    name: "Upload Video Gallery",
    icon: TuneIcon,
    galleryable: false,
    component: UploadVideoGalleryPage,
    underline: false,
  },
  {
    showable: false,
    path: `/photographer/advanced/promotional-media`,
    name: "Promotional Media",
    icon: TuneIcon,
    galleryable: false,
    component: PromotionalMediaPage,
    underline: false,
  },
  {
    showable: true,
    path: `/photographer/advanced`,
    name: "Advanced Functions",
    icon: TuneIcon,
    galleryable: false,
    component: AdvancedFunctions,
    underline: false,
  },
  {
    showable: true,
    path: `/photographer/profilev2`,
    name: "Profile",
    icon: PersonOutlineIcon,
    component: ProfileV2,
    underline: false,
  },
  {
    showable: false,
    path: `/photographer/howitworks`,
    name: "How It Works",
    icon: null,
    component: HowWork,
    underline: false,
  },
  {
    showable: true,
    path: `${BOSSFOTOS_INFO_SUBDOMAIN_BASE_URL}/info-centre/?top-category=photographers`,
    name: "Help",
    icon: HelpOutlineIcon,
    component: Help,
    underline: false,
    openLinkInNewBrowserTab: true,
  },
  {
    showable: true,
    path: `${BOSSFOTOS_INFO_SUBDOMAIN_BASE_URL}/privacy-policy`,
    name: "Privacy Policy",
    icon: LockOutlinedIcon,
    component: Privacy,
    underline: false,
    openLinkInNewBrowserTab: true,
  },
  {
    showable: true,
    path: `${BOSSFOTOS_INFO_SUBDOMAIN_BASE_URL}/terms`,
    name: "Terms & Conditions",
    icon: DescriptionOutlinedIcon,
    component: Terms,
    underline: false,
    openLinkInNewBrowserTab: true,
  },
];
